import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Link,
  Backdrop,
  CircularProgress} from "@mui/material";
import LegalLinks from "../../components/LegalLinks";
import { useLogin } from "../../hooks/useAuth";

function LoginPage(){
    const navigate = useNavigate();
    const login = useLogin();
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, boxSizing: 'border-box' }}>
            <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={login.isLoading}
                    >
                        <CircularProgress size={100} color="warning" />
                    </Backdrop>
                    <Container maxWidth="sm" style={{border:'solid black 2px', borderRadius:'10px', boxShadow: '5px 5px 5px 3px rgba(168,168,168,0.45)', backgroundColor:"white", margin:"auto", marginTop:"13vh", marginBottom:'20vh' }}>
                        <Formik
                            initialValues={{
                                userName: "",
                                password: "",
                            }}
                            validationSchema={Yup.object().shape({
                                userName: Yup.string().max(255).required("Username is required"),
                                password: Yup.string().max(255).required("Password is required"),
                            })}
                            onSubmit={async (values) => {
                                try {
                                    await login.mutateAsync({
                                        UserName: values.userName,
                                        Password: values.password,
                                    });
                                    navigate("/", { replace: true });
                                } catch {
                                    // toast handled in useLogin onError
                                }
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values,
                            }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mb={3}>
                                    <Typography color="textPrimary" variant="h2">
                                        Sign In
                                    </Typography>
                                </Box>
                                <Box mt={3} mb={1}></Box>
                                <TextField
                                    error={Boolean(touched.userName && errors.userName)}
                                    fullWidth
                                    helperText={touched.userName && errors.userName}
                                    label="Username"
                                    margin="normal"
                                    name="userName"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="text"
                                    value={values.userName}
                                    variant="outlined"
                                />
                                <TextField
                                    error={Boolean(touched.password && errors.password)}
                                    fullWidth
                                    helperText={touched.password && errors.password}
                                    label="Password"
                                    margin="normal"
                                    name="password"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="password"
                                    value={values.password}
                                    variant="outlined"
                                />
                                <Box my={2}>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting || login.isLoading}
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                    >
                                        Sign in now
                                    </Button>
                                </Box>
                                <Typography color="textSecondary" variant="body1">
                                    Don&apos;t have an account?{" "}
                                    <Link component={RouterLink} to="/register" variant="h6">
                                        Sign up
                                    </Link>
                                </Typography>
                                <Typography color="textSecondary" variant="body1">
                                    <Link component={RouterLink} to="/requestpassword" variant="h6">
                                        Forgot Login
                                    </Link>
                                </Typography>
                                <Box mt={2} mb={1}>
                                    <LegalLinks/>
                                </Box>
                            </form>
                            )}
                        </Formik>
                    </Container>
        </div>
    )
}

export default LoginPage;
